import PropTypes from 'prop-types';
import React, { Component }  from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Snap from 'snapsvg-cjs';
import { addNode } from '~app/actions/nodeList';
import Logging from '~app/core/logging';
import { withT, withResources } from "~app/BundleProvider";

const log = Logging.getLogger('app.components.snapchart');

class SnapChart extends Component {
  static propTypes = {
    // TODO src prop is redundant, remove from parent and use version instead
    src: PropTypes.string.isRequired,
    version: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
  }

  state = { svg: undefined }

  componentDidMount() {
    // update chart immediately after mount so work is re-included if user
    // visits footer pages and retuns to chart

    if (this.svgDiv) {
      this.svgRender()
        .then(() => {
          this.addNodeKeyboard();
          if (this.props.nodes.length) {
            this.updateChart(this.props);
          }
        });
    }
  }

  componentWillReceiveProps(next){
    // if version changes, remove current svg from dom and from component state
    if (next.version !== this.props.version) {
      // empty svgDiv element before re-adding snapSvg content in svgRender
      this.emptySVGElement();

      // first, get rid of svg in state, then recreate it in svgRender and update chart
      this.setState({ svg: undefined }, () =>
        this.svgRender()
          .then(() => {
            this.removeNodeKeyboard();
            this.addNodeKeyboard();
            this.updateChart(this.props);
          })
      );
    }
    else {
      this.updateChart(next);
    }
  }

  componentWillUnmount() {
    this.emptySVGElement();
    this.removeNodeKeyboard();
    // this.svgDiv.remove();
  }

  // adds a node using keypress by adding an event listener to .NodeButton elements
  addNodeKeyboard = () => {
    const buttons = document.querySelectorAll('.NodeButton');
    buttons.forEach(button => {
      let id = button.getAttribute("id");
      const [buttonId, title, className] = id.split(':');
      button.addEventListener('keypress', (e) =>
        this.handleKeyPress(e.keyCode, buttonId, title, className)
      );

    });
  }

  handleKeyPress = (keyCode, id, t, c) => {
    const enterKey = 13;
    const spaceKey = 32;

    if (keyCode === enterKey || keyCode === spaceKey){
      this.props.addNode({buttonId: id, title: t, className: c});
    }
  }

  // removes event listener added by addNodeKeyboard
  removeNodeKeyboard = () => {
    const buttons = document.querySelectorAll('.NodeButton');
    buttons.forEach(button => {
      let id = button.getAttribute("id");
      const [buttonId, title, className] = id.split(':');
      button.removeEventListener('keypress', (e) =>
        this.handleKeyPress(e.keyCode, buttonId, title, className)
      );

    });
  }

  emptySVGElement = () => {
    while (this.svgDiv.hasChildNodes()) {
      this.svgDiv.removeChild(this.svgDiv.firstChild);
    }
  }

  getVersion = () => {
    const { r } = this.props;
    return this.props.version === "standard"
      ? r("chart-detailed.svg")
      : r("chart-basic.svg");
  }

  svgRender = () => {
    const { t } = this.props;
    return new Promise((resolve, reject) => {
      let element = Snap(this.svgDiv);
      Snap.load(this.getVersion(), function(data){
        if (element) {
          element.append(data);
          let svg = element.select("svg");
          var buttons = svg.selectAll(".NodeButton");

          // var buttonGroup = svg.select("#buttons");
          buttons.forEach(button => {
            // let c = button.attr("data-node-class");
            // let t = button.attr("data-node-text");
            let id = button.attr("id");
            if (id) {
              const [buttonId, title, className] = id.split(':');
              button.attr({'aria-label': t(title), 'tabindex': 0, 'role': 'button'});

              button.click(event => {
                this.props.addNode({buttonId: buttonId, title: title, className: className});
              });
            }
          });

          this.setState({
            svg: svg,
          }, () => resolve());
        }
        else {
          log.error("Failed to load SVG");
          reject();
        }
      }, this);
    });
  }


  updateChart = (next) => {
    // clear the visible arrows
    let visible = this.state.svg.selectAll(".NodeArrow--visible");
    visible.forEach(x=>{
      x.removeClass(`NodeArrow--visible
                     NodeArrow--selected
                     NodeArrow--stroke1
                     NodeArrow--stroke2
                     NodeArrow--stroke3
                     NodeArrow--stroke4`);
    });

    // clear the old visited nodes
    var visited = this.state.svg.selectAll(".NodeButton--visited");
    visited.forEach(x=>{
      x.removeClass("NodeButton--visited");
    });

    // set the new visited nodes
    next.nodes.forEach(x=>{
      let button = this.state.svg.select("#" + x.buttonId + "\\:" + x.title + "\\:" + x.className);
      if (button) {
        button.addClass("NodeButton--visited");
      }
    });

    // clear any old selected node
    var selected = this.state.svg.select(".NodeButton--selected");
    if(selected !== null)
      selected.removeClass("NodeButton--selected");

    // set any new selected node
    selected = this.state.svg.select("#" + next.selected.buttonId + "\\:" + next.selected.title + "\\:" + next.selected.className);
    if(selected !== null)
      selected.addClass("NodeButton--selected");

    let a = {};
    // set the visible arrows
    for(let i=0; i<next.nodes.length-1; i++){
      let fromNode = next.nodes[i];
      let toNode = next.nodes[i+1];
      //let prevNode = i>0?next.nodes[i-1]:null;
      let fromID = fromNode.buttonId.split("-")[1];
      let toID = toNode.buttonId.split("-")[1];
      let id = "arrow-"+fromID+"-"+toID;
      let arrow = this.state.svg.select("#"+id);
      if(arrow != null){
        if(a[id] === undefined)
          a[id] = 1;
        else
          a[id] += 1;
        a[id] = a[id]>4?4:a[id];
        let strokeClass = "NodeArrow--stroke" + a[id];
        arrow.removeClass("NodeArrow--stroke1 NodeArrow--stroke2 NodeArrow--stroke3 NodeArrow--stroke4");
        arrow.addClass("NodeArrow--visible " + strokeClass);
      }
    }

    // Find the index of the selected node
    let index = next.nodes.findIndex(node => { return node.id===next.selected.id; });
    // set selected styles
    if(index >= 0) {
      let selectedNode = next.nodes[index];
      let selectedID = selectedNode.buttonId.split("-")[1];

      if(index < next.nodes.length - 1){
        let nextNode = next.nodes[index+1];
        let nextID = nextNode.buttonId.split("-")[1];
        // Duplicate sequential nodes don't have arrows, so don't try to select
        if(nextID !== selectedID){
          let id = "arrow-"+selectedID+"-"+nextID;
          let arrow = this.state.svg.select("#"+id);
          arrow.addClass("NodeArrow--selected");
        }
      }

      if(index > 0){
        let prevNode = next.nodes[index-1];
        let prevID = prevNode.buttonId.split("-")[1];
        // Duplicate sequential nodes don't have arrows, so don't try to select
        if(prevID !== selectedID){
          let id = "arrow-"+prevID+"-"+selectedID;
          let arrow = this.state.svg.select("#"+id);
          arrow.addClass("NodeArrow--selected");
        }
      }
    }

    var firstBtn = this.state.svg.select(".NodeButton--first");
    if(firstBtn !==null)
      firstBtn.removeClass("NodeButton--first");
    if(next.nodes.length > 0) {
      let firstId = next.nodes[0].buttonId;
      let firstTitle = next.nodes[0].title;
      let firstClassName = next.nodes[0].className;
      firstBtn = this.state.svg.select("#" + firstId + "\\:" + firstTitle + "\\:" + firstClassName);
      if(firstBtn !== null)
        firstBtn.addClass("NodeButton--first");
    }

    var finalBtn = this.state.svg.select(".NodeButton--final");
    if(finalBtn !==null)
      finalBtn.removeClass("NodeButton--final");
    if(next.nodes.length > 0) {
      let finalId = next.nodes[next.nodes.length-1].buttonId;
      let finalTitle = next.nodes[next.nodes.length-1].title;
      let finalClassName = next.nodes[next.nodes.length-1].className;
      finalBtn = this.state.svg.select("#" + finalId + "\\:" + finalTitle + "\\:" + finalClassName);
      if(finalBtn !== null)
        finalBtn.addClass("NodeButton--final");
    }
  }

  render() {
    return (
      <div
        className="SnapChart"
        ref={d=>this.svgDiv=d}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  nodes: state.nodeList.present.nodes,
  selected: state.nodeList.present.selected,
  version: state.app.version,
});

const mapDispatchToProps = {
  addNode,
};

export default compose(
  withT,
  withResources,
  connect(mapStateToProps, mapDispatchToProps)
)(SnapChart);



// WEBPACK FOOTER //
// ./src/pages/Main/SnapChart.js